export default [
  {
    header: '—— ข้อมูลส่วนตัว ——',
    resource: 'normal',
    action: 'manage',
  },
  // {
  //   title: 'เชื่อมต่อ Line',
  //   route: 'connect',
  //   icon: 'LinkIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  // {
  //   title: 'คูปองของฉัน',
  //   route: 'me-coupon',
  //   icon: 'GiftIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  // {
  //   title: 'คูปองแจก',
  //   route: 'free-coupon',
  //   icon: 'GiftIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  {
    title: 'ที่อยู่จัดส่ง',
    route: 'me-address',
    icon: 'TruckIcon',
    resource: 'normal',
    action: 'manage',
  },
  {
    title: 'ข้อมูลทั่วไป',
    route: 'me-information',
    icon: 'UserIcon',
    resource: 'normal',
    action: 'manage',
  },
  // {
  //   title: 'เสนอแนะ/แจ้งปัญหา',
  //   route: 'me-problem',
  //   icon: 'MessageSquareIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
]
